import {useEffect, useMemo} from 'react';
import type {DocumentChoice, SelectOption} from '@chekin/core';
import {DocumentSidePreview} from '../documentCatalog/DocumentSidePreview';
import {preloadDocumentGuide} from '../documentCatalog/preloadDocumentGuide';
import {resolveDocumentVisual} from '../documentCatalog/resolveDocumentVisual';

type Props = {
  nationality?: SelectOption | null;
  documentType?: SelectOption<DocumentChoice> | null;
  withSelfie?: boolean;
  className?: string;
};

function IVDocumentPreview({nationality, documentType, withSelfie, className}: Props) {
  const documentChoice = documentType?.data;
  const visual = useMemo(
    () => resolveDocumentVisual({countryCode: nationality?.value, documentChoice}),
    [nationality?.value, documentChoice],
  );

  useEffect(() => {
    preloadDocumentGuide(visual);
  }, [visual]);

  if (!nationality || !visual) return null;

  return (
    <DocumentSidePreview
      key={documentChoice?.value}
      visual={visual}
      sides="all"
      layout="auto"
      twoSides={Boolean(documentChoice?.two_sides)}
      withSelfie={withSelfie}
      documentValue={documentChoice?.value}
      className={className}
    />
  );
}

export {IVDocumentPreview};
